export default "__VITE_ASSET__aac07c89__"